import React from "react";
import {Container, HStack} from "@chakra-ui/react";
import Profiler from "./Profiler";
import './Portfolio.css'

function Portfolio(props) {
    return (
        <Container
            className={'portfolio'}
            width={'100%'}
            maxW={'100%'}
            height={'100%'}
            maxH={'100%'}
            padding={0}
        >
            <div className={'left plain'}/>
            <div className={'right cover'}/>
            <HStack>
                <Profiler/>
                <Profiler/>
                <Profiler/>
            </HStack>
            <div className={'down cover'}/>
        </Container>
    );
}

export default Portfolio;
